import { StoreThemes } from '../../Types/StoreTypes';

export const SET_ALL_THEMES = 'SET_ALL_THEMES';
export const SET_SELECTED_THEME = 'SET_SELECTED_THEME';
export const SET_SELECTED_THEME_SWITCHER_STATE = 'SET_SELECTED_THEME_SWITCHER_STATE';
export const SET_CURRENT_THEME_COLOR = 'SET_CURRENT_THEME_COLOR';

export function setAllThemes(themes: StoreThemes['allThemes']) {
    return { type: SET_ALL_THEMES, payload: themes };
}

export function setSelectedTheme(theme: StoreThemes['selectedTheme']) {
    return { type: SET_SELECTED_THEME, payload: theme };
}

export function setSelectedThemeSwitcherState(state: StoreThemes['themeSwitcherState']) {
    return { type: SET_SELECTED_THEME_SWITCHER_STATE, payload: state };
}

export function setCurrentThemeColor(color: StoreThemes['currentThemeColor']) {
    return { type: SET_CURRENT_THEME_COLOR, payload: color };
}
